import React, { useState } from "react"
import { navigate } from "gatsby"
import { Grid, Box, Button } from "@material-ui/core"
import { Alert } from "@material-ui/lab"
import { useForm } from "react-hook-form"
import firebase from "../Firebase"
import Wraptypo from "../components/WrapTypo"
import Dialog from "@material-ui/core/Dialog"
import { getThemeProps } from "@material-ui/styles"
import { useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import Select from "@material-ui/core/Select"
import Modal from "@material-ui/core/Modal"
import Backdrop from "@material-ui/core/Backdrop"
import Fade from "@material-ui/core/Fade"
import { makeStyles } from "@material-ui/core/styles"
import MenuItem from "@material-ui/core/MenuItem"
import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import styled from "styled-components"
import WrapTypo from "../components/WrapTypo"

const RootBox = styled(Box)`
  select {
    width: 100%;
    padding: 16px 0 16px 8px;
    background: yellow;
    border: 1px solid rgb(158, 158, 158);
    border-radius: 3px;
    color: rgb(158, 158, 158);
    background-color: #242424;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  ::selection {
    background-color: cyan;
  }
`

const isEmpty = obj => !Object.keys(obj).length

const emailRule = () => ({
  pattern: {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    message: "「メールアドレス」の入力形式が正しくありません。",
  },
})
const phoneNumberRule = {
  minLength: {
    value: 6,
    message: "「電話番号」の入力文字数が少なすぎます",
  },
  maxLength: {
    value: 12,
    message: "「電話番号」の入力文字数が多すぎます",
  },
  pattern: {
    value: /^[0-9]+$/,
    message: "「電話番号」の入力形式が正しくありません",
  },
}

const textRule = name => ({
  maxLength: {
    value: 500,
    message: `「${name}」の入力文字数が多すぎます`,
  },
})

const contextRule = () => ({
  maxLength: {
    value: 50000,
    message: "「お問い合わせ内容」入力文字数が多すぎます",
  },
})

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "scroll",
  },
  paper: {
    backgroundColor: "#000",
    border: "2px solid #9E9E9E",
    borderRadius: "0",
    padding: theme.spacing(2, 4, 3),
    outline: "none",
  },
}))

export const ContactForm = () => {
  const { handleSubmit, register, errors } = useForm()
  const [loading, setLoading] = React.useState(false)
  const [scroll, setScroll] = React.useState("paper")
  const [elements, setElement] = useState({
    contactType: "選択して下さい",
    company: "",
    division: "",
    jobTitle: "",
    name: "",
    mail: "",
    introductionName: "",
    title: "",
    contactDetail: "",
  })
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const onSubmit = values => {
    setOpen(false)
    setLoading(true)
    const docId = firebase
      .firestore()
      .collection(
        values.contactType === "採用について" ? "recruit" : "contacts"
      )
      .doc().id

    firebase
      .firestore()
      .collection(
        values.contactType === "採用について" ? "recruit" : "contacts"
      )
      .doc(docId)
      .set({
        ...values,
        created_at: firebase.firestore.FieldValue.serverTimestamp(),
        updated_at: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then(() => {
        navigate("/contactsResult/", { state: { result: "success" } })
        console.log("送信成功")
        setLoading(false)
      })
      .catch(e => {
        navigate("/contactsResult/", { state: { result: "faild" } })
        setLoading(false)
        console.log("送信失敗", e)
      })
  }

  const errKeys = Object.keys(errors)
  return (
    <>
      <RootBox width="100%" maxWidth="1080px" margin="auto">
        <form onSubmit={handleSubmit(onSubmit)}>
          <RootBox width="100%" padding="0 30px">
            <ItemTilte text="お問い合わせ種別*" />
            <select
              name="contactType"
              id="sources"
              placeholder=""
              value={elements.contactType}
              style={{ color: "#fff" }}
              onChange={e => {
                // オブジェクトを分解して、nameの部分だけ新しい値をセットする
                setElement({
                  ...elements,
                  contactType: e.target.value,
                })
              }}
            >
              <option value={""}>お問い合わせ種別*</option>
              <option value={"新規の営業のご案内"}>新規の営業のご案内</option>
              <option value={"弊社についてのお問い合わせ"}>
                弊社についてのお問い合わせ
              </option>
              <option value={"採用について"}>採用について</option>
              <option value={"その他"}>その他</option>
            </select>

            <Grid item xs={12}>
              <Box style={{ textAlign: "left" }} my={1}>
                {/* <InputFormItem
                      title="Name/名前"
                      placeholder="会社名・学校名*"
                      name="company"
                      register={register}
                      rule={textRule("会社名")}
                      requiredItemFlag={true}
                      subTitle="入力必須項目です。"
                    /> */}
                <Grid container>
                  <Box width="100%">
                    <Grid item>
                      <ItemTilte text="会社名・学校名*" />
                      <input
                        type="text"
                        name="company"
                        // ref={register({
                        //   required: `「会社名・学校名*」の項目が未入力です`,
                        //   ...textRule("会社名"),
                        // })}
                        placeholder="会社名・学校名*"
                        style={{
                          height: "55px",
                          fontSize: "16px",
                          width: "100%",
                          border: "0",
                          fontSize: "14px",
                          padding: "0 10px",
                          backgroundColor: "#242424",
                          border: "1px #9E9E9E solid",
                          borderRadius: "3px",
                          color: "#fff",
                        }}
                        onChange={e => {
                          // オブジェクトを分解して、nameの部分だけ新しい値をセットする
                          setElement({
                            ...elements,
                            company: e.target.value,
                          })
                        }}
                      />
                    </Grid>
                  </Box>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box style={{ textAlign: "left" }} my={1}>
                <Grid container>
                  <Box width="100%">
                    <Grid item>
                      <ItemTilte text="部署・学部名" />
                      <input
                        type="text"
                        name="division"
                        // ref={register({
                        //   required: `「部署・学部名」の項目が未入力です`,
                        //   ...textRule("会社名"),
                        // })}
                        placeholder="部署・学部名"
                        style={{
                          height: "55px",
                          fontSize: "16px",
                          width: "100%",
                          border: "0",
                          fontSize: "14px",
                          padding: "0 10px",
                          backgroundColor: "#242424",
                          border: "1px #9E9E9E solid",
                          borderRadius: "3px",
                          color: "#fff",
                        }}
                        onChange={e => {
                          // オブジェクトを分解して、nameの部分だけ新しい値をセットする
                          setElement({
                            ...elements,
                            division: e.target.value,
                          })
                        }}
                      />
                    </Grid>
                  </Box>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box style={{ textAlign: "left" }} my={1}>
                <Grid container>
                  <Box width="100%">
                    <Grid item>
                      <ItemTilte text="役職名" />
                      <input
                        type="text"
                        name="jobTitle"
                        // ref={register({
                        //   required: `「役職名」の項目が未入力です`,
                        //   ...textRule("お名前"),
                        // })}
                        placeholder="役職名"
                        style={{
                          height: "55px",
                          fontSize: "16px",
                          width: "100%",
                          border: "0",
                          fontSize: "14px",
                          padding: "0 10px",
                          backgroundColor: "#242424",
                          border: "1px #9E9E9E solid",
                          borderRadius: "3px",
                          color: "#fff",
                        }}
                        onChange={e => {
                          // オブジェクトを分解して、nameの部分だけ新しい値をセットする
                          setElement({
                            ...elements,
                            jobTitle: e.target.value,
                          })
                        }}
                      />
                    </Grid>
                  </Box>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box style={{ textAlign: "left" }} my={1}>
                <Grid container>
                  <Box width="100%">
                    <Grid item>
                      <ItemTilte text="お名前*" />
                      <input
                        type="text"
                        name="name"
                        // ref={register({
                        //   required: `「お名前*」の項目が未入力です`,
                        //   ...phoneNumberRule,
                        // })}
                        placeholder="お名前*"
                        style={{
                          height: "55px",
                          fontSize: "16px",
                          width: "100%",
                          border: "0",
                          fontSize: "14px",
                          padding: "0 10px",
                          backgroundColor: "#242424",
                          border: "1px #9E9E9E solid",
                          borderRadius: "3px",
                          color: "#fff",
                        }}
                        onChange={e => {
                          // オブジェクトを分解して、nameの部分だけ新しい値をセットする
                          setElement({
                            ...elements,
                            name: e.target.value,
                          })
                        }}
                      />
                    </Grid>
                  </Box>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box style={{ textAlign: "left" }} my={1}>
                <Grid container>
                  <Box width="100%">
                    <Grid item>
                      <ItemTilte text="メールアドレス*" />
                      <input
                        type="text"
                        name="mail"
                        // ref={register({
                        //   required: `「メールアドレス*」の項目が未入力です`,
                        //   ...emailRule,
                        // })}
                        placeholder="メールアドレス*"
                        style={{
                          height: "55px",
                          fontSize: "16px",
                          width: "100%",
                          border: "0",
                          fontSize: "14px",
                          padding: "0 10px",
                          backgroundColor: "#242424",
                          border: "1px #9E9E9E solid",
                          borderRadius: "3px",
                          color: "#fff",
                        }}
                        onChange={e => {
                          // オブジェクトを分解して、nameの部分だけ新しい値をセットする
                          setElement({
                            ...elements,
                            mail: e.target.value,
                          })
                        }}
                      />
                    </Grid>
                  </Box>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box style={{ textAlign: "left" }} my={1}>
                <Grid container>
                  <Box width="100%">
                    <Grid item>
                      <ItemTilte text="ご紹介企業名・個人名" />
                      <input
                        type="text"
                        name="introductionName"
                        // ref={register({
                        //   required: `「ご紹介企業名・個人名」の項目が未入力です`,
                        //   ...phoneNumberRule,
                        // })}
                        placeholder="ご紹介企業名・個人名"
                        style={{
                          height: "55px",
                          fontSize: "16px",
                          width: "100%",
                          border: "0",
                          fontSize: "14px",
                          padding: "0 10px",
                          backgroundColor: "#242424",
                          border: "1px #9E9E9E solid",
                          borderRadius: "3px",
                          color: "#fff",
                        }}
                        onChange={e => {
                          // オブジェクトを分解して、nameの部分だけ新しい値をセットする
                          setElement({
                            ...elements,
                            introductionName: e.target.value,
                          })
                        }}
                      />
                    </Grid>
                  </Box>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box style={{ textAlign: "left" }} my={1}>
                <Grid container>
                  <Box width="100%">
                    <Grid item>
                      <ItemTilte text="件名" />
                      <input
                        type="text"
                        name="title"
                        // ref={register({
                        //   required: `「件名」の項目が未入力です`,
                        //   ...phoneNumberRule,
                        // })}
                        placeholder="件名"
                        style={{
                          height: "55px",
                          fontSize: "16px",
                          width: "100%",
                          border: "0",
                          fontSize: "14px",
                          padding: "0 10px",
                          backgroundColor: "#242424",
                          border: "1px #9E9E9E solid",
                          borderRadius: "3px",
                          color: "#fff",
                        }}
                        onChange={e => {
                          // オブジェクトを分解して、nameの部分だけ新しい値をセットする
                          setElement({
                            ...elements,
                            title: e.target.value,
                          })
                        }}
                      />
                    </Grid>
                  </Box>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box style={{ textAlign: "left" }} my={1}>
                <Grid container>
                  <Box width="100%">
                    <Grid item>
                      <ItemTilte text="お問い合わせ内容*" />
                      <textarea
                        name="contactDetail"
                        // ref={register({
                        //   required: `「お問い合わせ内容*」の項目が未入力です`,
                        //   ...contextRule,
                        // })}
                        placeholder="お問い合わせ内容をご自由に記入してください*"
                        style={{
                          height: "400px",
                          fontSize: "16px",
                          width: "100%",
                          border: "0",
                          fontSize: "14px",
                          padding: "5px 10px",
                          backgroundColor: "#242424",
                          border: "1px #9E9E9E solid",
                          borderRadius: "3px",
                          color: "#fff",
                        }}
                        onChange={e => {
                          // オブジェクトを分解して、nameの部分だけ新しい値をセットする
                          setElement({
                            ...elements,
                            contactDetail: e.target.value,
                          })
                        }}
                      />
                    </Grid>
                  </Box>
                </Grid>
              </Box>
            </Grid>
          </RootBox>
        </form>
        <Box width="80%" margin="auto" my={1}>
          <Box textAlign="center">
            {!loading ? (
              <Button
                // type="button"
                //type="submit"
                // onClick={confirmationModal}
                onClick={handleOpen}
                // onClick={onSubmit()}
                style={{
                  backgroundColor: "#242424",
                  border: "solid 1px #9E9E9E",
                  borderRadius: "0",
                  maxWidth: "450px",
                  width: "100%",
                }}
              >
                <Wraptypo mt={"8px"} mb={"8px"} color="#ffffff">
                  確認
                </Wraptypo>
              </Button>
            ) : (
              <Button
                disabled={true}
                type="submit"
                style={{
                  backgroundColor: "#D8D8D8",
                  borderRadius: "0",
                  maxWidth: "450px",
                  width: "100%",
                }}
              >
                <Wraptypo mt={"8px"} mb={"8px"} color="#242424">
                  送信
                </Wraptypo>
              </Button>
            )}
          </Box>
        </Box>
      </RootBox>
      <Box mb={4} />
      {/* Dialog */}

      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        maxWidth="md"
        PaperProps={{
          style: {
            maxWidth: "800px",
            width: "100%",
            border: "2px solid #9E9E9E",
            borderRadius: "0",
          },
        }}
      >
        <Box
          width="100%"
          bgcolor="#000"
          // border="2px solid #9E9E9E"
          // borderRadius="0"
        >
          <Box width="80%" margin="auto" marginBottom="20px">
            <ModalContent
              title="お問い合わせ種別"
              content={elements.contactType}
            />
            <ModalContent title="会社名・学校名" content={elements.company} />
            <ModalContent title="部署・学部名" content={elements.division} />
            <ModalContent title="役職名" content={elements.jobTitle} />
            <ModalContent title="お名前" content={elements.name} />
            <ModalContent title="メールアドレス" content={elements.mail} />
            <ModalContent
              title="ご紹介企業名・個人名"
              content={elements.introductionName}
            />
            <ModalContent title="件名" content={elements.title} />
            <ModalContent
              title="お問い合わせ内容"
              content={elements.contactDetail}
            />

            <form onSubmit={handleSubmit(onSubmit)}>
              <input
                type="hidden"
                name="contactType"
                value={elements.contactType}
                ref={register({
                  required: `「お問い合わせ種別*」の項目が未入力です`,
                  ...textRule("お問い合わせ種別"),
                })}
              />

              <input
                type="hidden"
                name="company"
                value={elements.company}
                ref={register({
                  required: `「学校名・会社名*」の項目が未入力です`,
                  ...textRule("学校名・会社名"),
                })}
              />
              <input
                type="hidden"
                name="division"
                value={elements.division}
                ref={register({ required: false })}
              />

              <input
                type="hidden"
                name="jobTitle"
                value={elements.jobTitle}
                ref={register({ required: false })}
              />

              <input
                type="hidden"
                name="name"
                value={elements.name}
                ref={register({
                  required: `「お名前*」の項目が未入力です`,
                  ...textRule("お名前"),
                })}
              />
              <input
                type="hidden"
                name="mail"
                value={elements.mail}
                ref={register({
                  required: `「メールアドレス*」の項目が未入力です`,
                  ...emailRule("メールアドレス"),
                })}
              />
              <input
                type="hidden"
                name="introductionName"
                value={elements.introductionName}
                ref={register({ required: false })}
              />
              <input
                type="hidden"
                name="title"
                value={elements.title}
                ref={register({ required: false })}
              />
              <input
                type="hidden"
                name="contactDetail"
                value={elements.contactDetail}
                ref={register({
                  required: `「お問い合わせ内容*」の項目が未入力です`,
                  ...contextRule("お問い合わせ内容"),
                })}
              />
              {!isEmpty(errors) && errKeys.length > 0 && (
                <Box mb={2}>
                  <Alert severity="error">
                    {errKeys.map(k => (
                      <React.Fragment key={k}>
                        ・{errors[k].message}
                        <br />
                      </React.Fragment>
                    ))}
                  </Alert>
                </Box>
              )}
              <Box textAlign="center">
                <Button
                  onClick={_ => setOpen(c => !c)}
                  style={{
                    backgroundColor: "#242424",
                    border: "solid 1px #9E9E9E",
                    borderRadius: "0",
                    maxWidth: "450px",
                    minWidth: "180px",
                    width: "100%",
                    marginBottom: "32px",
                  }}
                >
                  <Wraptypo
                    mt={"8px"}
                    mb={"8px"}
                    ls="2px"
                    fw="700"
                    color="#ffffff"
                  >
                    修正する
                  </Wraptypo>
                </Button>
                <Button
                  onClick={_ => onSubmit}
                  type="submit"
                  style={{
                    backgroundColor: "#fff",
                    border: "solid 1px #9E9E9E",
                    borderRadius: "0",
                    maxWidth: "450px",
                    minWidth: "180px",
                    width: "100%",
                  }}
                >
                  <Wraptypo
                    mt={"8px"}
                    mb={"8px"}
                    fw="700"
                    ls="2px"
                    color="#505050"
                  >
                    送信
                  </Wraptypo>
                </Button>
              </Box>
            </form>
          </Box>
        </Box>
      </Dialog>
    </>
  )
}

const ModalContent = ({ title, content }) => {
  return (
    <>
      <Box my={1}>
        <Wraptypo color="#fff" ls="2px" lh="200%" fw="700">
          【{title}】
        </Wraptypo>
        <Box pl={2}>
          <Wraptypo color="#fff" lh="200%" xls="2px">
            {content}
          </Wraptypo>
        </Box>
      </Box>
    </>
  )
}

const InputFormItem = ({
  title,
  placeholder,
  name,
  register,
  rule,
  requiredItemFlag,
  subTitle,
}) => {
  return (
    <>
      <Grid container>
        <Box width="100%">
          <Grid item>
            <input
              type="text"
              name={name}
              ref={register({
                required: `「${title}」の項目が未入力です`,
                ...rule,
              })}
              placeholder={placeholder}
              style={{
                height: "55px",
                fontSize: "16px",
                width: "100%",
                border: "0",
                fontSize: "14px",
                padding: "0 10px",
                backgroundColor: "#242424",
                border: "1px #9E9E9E solid",
                borderRadius: "3px",
              }}
              // onChange={e => {
              //   // オブジェクトを分解して、nameの部分だけ新しい値をセットする
              //   setElement({
              //     ...elements,
              //     elementName: e.target.value,
              //   })
              //   console.log(elements)
              // }}
            />
          </Grid>
        </Box>
      </Grid>
    </>
  )
}

const TextAreaFormItem = ({
  title,
  placeholder,
  name,
  register,
  rule,
  requiredItemFlag,
  subTitle,
}) => {
  return (
    <>
      <Grid container>
        <Box width="100%">
          <Grid item>
            <textarea
              name={name}
              ref={register({
                required: `「${title}」の項目が未入力です`,
                ...rule,
              })}
              placeholder={placeholder}
              style={{
                height: "400px",
                fontSize: "16px",
                width: "100%",
                border: "0",
                fontSize: "14px",
                padding: "5px 10px",
                backgroundColor: "#242424",
                border: "1px #9E9E9E solid",
                borderRadius: "3px",
              }}
            />
          </Grid>
        </Box>
      </Grid>
    </>
  )
}

const SelectFormItem = ({
  title,
  optionsText,
  register,
  name,
  requiredItemFlag,
  subTitle,
}) => {
  return (
    <>
      <Grid container>
        <Box width="100%">
          <Grid item>
            <select
              name={name}
              ref={register({ required: `「${title}」の項目が未選択です` })}
              style={{
                width: "100%",
                height: "55px",
                fontSize: "16px",
                border: "0",
                fontSize: "14px",
              }}
            >
              {optionsText.map(x => (
                <option key={x}>{x}</option>
              ))}
            </select>
          </Grid>
        </Box>
      </Grid>
    </>
  )
}

const GridResponsiveSpace = ({ children }) => {
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down("xs"))

  return (
    <Grid container spacing={isSmall ? 0 : 3}>
      {children}
    </Grid>
  )
}

const ItemTilte = props => {
  return (
    <WrapTypo
      fs="16px"
      xsfs="14px"
      xsta="left"
      lh="350%"
      ls="5%"
      color="#fff"
      fw="700"
      style={{ margin: "auto" }}
    >
      {props.text}
    </WrapTypo>
  )
}
